import {GraphicRef, GraphicType, IGraphic} from '@mintdata/mint-kit/api/assets/Graphic';

export enum Illustration1Category
{
    Place = 'Place',
    Finance = 'Finance',
    Tech = 'Tech',
    SportAndActivities = 'Sport & Activities',
    People = 'People',
    Nature = 'Nature',
    History = 'History',
    Work = 'Work',
    Jobs = 'Jobs',
    StartUp = 'Start-Up',
    Learn = 'Learn',
    AppBuilder = 'App Builder',
    Ecology = 'Ecology',
    ECommerce = 'E-Commerce',
    SocialMedia = 'Social Media',
    PopCulture = 'Pop-Culture',
    World = 'World',
    Weather = 'Weather',
    Item = 'Item'
}

export interface IIllustration1Filters
{
    categories:Illustration1Category[];
}

export class Illustration1 implements IGraphic
{
    constructor(public name:string,
                public label:string,
                public categories:Illustration1Category[],
                public svg:string)
    {
    }

    public getType():GraphicType
    {
        return GraphicType.Illustration1;
    }

    public getRef():GraphicRef
    {
        return new GraphicRef(this.name, this.getType());
    }
}
